<template>
  <div>
    <el-button v-for="(item,index) in list" :key="index" @click="$router.push(item.path)" style="margin-top: 10px;">{{item.meta.title}}</el-button>
  </div>
</template>
<script>

export default {
  name: 'all-router',
  components: {},
  props: [],
  data () {
    return {
      list: []
    }
  },
  async created () {
    this.list = this.$router.options.routes
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {}
}
</script>
